import React, { FC } from 'react'
import { ReactSVG } from 'react-svg'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { setPath, setUrlParam } from '../../../utils/url'
import { URL } from '../../constants/url'
import { Link, useParams } from 'react-router-dom'
import { isAdministrator } from '../../../utils/role'
import ANALYZE_REPORT from '../../constants/analyzeReport'
import EXPORT_LIST from '../../constants/export'

type LangValue = 'ja' | 'en'

interface Props {
  isOpen: boolean
  toggleCallback: VoidFunction
}

const SideBarSub: FC<Props> = (props) => {
  const {
    isOpen,
    toggleCallback,
  } = props

  const {
    login,
  } = useSelector((state: RootState) => state)

  const { language } = useParams<{ language: LangValue }>()

  const buildSVG = (isUpgrade: boolean, iconFileName: string) => {
    const filePath = `/static/images/icon/${iconFileName}.svg`
    return (
      <ReactSVG
        src={filePath}
        className={classNames('icon', {
          isUpgrade: isUpgrade,
        })}
        wrapper="span"
      />
    )
  }

  return (
    <>
      {
        (location.pathname.match(URL.ANALYZE.path) || location.pathname.match(URL.EXPORT.path)) && isAdministrator(login.role) ? (
          <div className="side_sub_wrap">
            <div className="tools">
              <div className="calendar_text">
                <div />
                <button
                  type="button"
                  className={`menu_toggle ${isOpen && "display"}`}
                  onClick={() => toggleCallback()}
                >
                  <div className={`menu ${isOpen && "active"}`}>
                    <FontAwesomeIcon icon={['fas', 'angle-double-left']} />
                  </div>
                </button>
              </div>
            </div>
            <section className="side_sub">
              <Link
                to={setPath(URL.ANALYZE.path, language)}
                className={classNames({
                  active: location.pathname.match(URL.ANALYZE.path) && location.pathname.split("/").length === 3,
                  item: true,
                })}
              >
                <div className="name_label">
                  <FontAwesomeIcon
                    icon={['fas', 'angle-right']}
                    className="arrow_icon"
                  />
                  <div className="name_area">
                    {buildSVG(false, "icon-flask")}
                    組織分析
                  </div>
                </div>
              </Link>
              <Link
                to={setPath(URL.APP_ANALYZE.path, language)}
                className={classNames({
                  active: location.pathname.match(URL.APP_ANALYZE.path),
                  item: true,
                  indent_1: true,
                })}
              >
                <div className="name_label">
                  <FontAwesomeIcon
                    icon={['fas', 'angle-right']}
                    className="arrow_icon"
                  />
                  <div className="name_area">
                    {buildSVG(false, "icon-report")}
                    アプリケーション分析
                  </div>
                </div>
              </Link>
              <Link
                to={setPath(URL.ANALYZE_REPORT.path, language)}
                className={classNames({
                  active: location.pathname.match(URL.ANALYZE_REPORT.path) && location.pathname.split("/").length === 4,
                  item: true,
                  indent_1: true,
                })}
              >
                <div className="name_label">
                  <FontAwesomeIcon
                    icon={['fas', 'angle-right']}
                    className="arrow_icon"
                  />
                  <div className="name_area">
                    {buildSVG(false, "icon-report")}
                    分析レポート
                  </div>
                </div>
              </Link>
              {
                ANALYZE_REPORT.map((value) => (
                  <React.Fragment key={`side_sub_${value.key}`}>
                    <Link
                      to={setPath(setUrlParam(
                        URL.ANALYZE_REPORT_DETAIL.path,
                        [
                          { key: 'type', value: value.key },
                        ],
                      ), language)}
                      className={classNames({
                        active: location.pathname.match(setUrlParam(
                          URL.ANALYZE_REPORT_DETAIL.path,
                          [
                            { key: 'type', value: value.key },
                          ],
                        )),
                        item: true,
                        indent_2: true,
                      })}
                    >
                      <div className="name_label">
                        <FontAwesomeIcon
                          icon={['fas', 'angle-right']}
                          className="arrow_icon"
                        />
                        <div className="name_area">
                          {buildSVG(false, "icon-report")}
                          {value.title}
                        </div>
                      </div>
                    </Link>
                  </React.Fragment>
                ))
              }
              <Link
                to={setPath(URL.EXPORT.path, language)}
                className={classNames({
                  active: location.pathname.match(URL.EXPORT.path) && location.pathname.split("/").length === 3,
                  item: true,
                  indent_1: true,
                })}
              >
                <div className="name_label">
                  <FontAwesomeIcon
                    icon={['fas', 'angle-right']}
                    className="arrow_icon"
                  />
                  <div className="name_area">
                    <FontAwesomeIcon
                      icon={['fas', 'file-download']}
                      className="icon task"
                    />
                    データエクスポート
                  </div>
                </div>
              </Link>
              {
                EXPORT_LIST.map((value) => (
                  <React.Fragment key={`side_sub_${value.text}`}>
                    <Link
                      to={setPath(value.url, language)}
                      className={classNames({
                        active: location.pathname.match(value.url),
                        item: true,
                        indent_1: value.indent_1,
                        indent_2: value.indent_2,
                      })}
                    >
                      <div className="name_label">
                        <FontAwesomeIcon
                          icon={['fas', 'angle-right']}
                          className="arrow_icon"
                        />
                        <div className="name_area">
                          <FontAwesomeIcon
                            icon={['fas', value.icon]}
                            className="icon task"
                          />
                          {value.title}
                        </div>
                      </div>
                    </Link>
                  </React.Fragment>
                ))
              }
            </section>
          </div>
        ) : (
          <>
          </>
        )
      }
    </>
  )
}

export default SideBarSub
